export default __webpack_public_path__ + "static/eco-f3b9975c9cae251415dd8e98c8aaeb17.svg";